import { Link } from 'react-router-dom';
import { i18n } from '@wms/shared';
import { useAuth } from '../lib/auth-context.js';
import { staffRouteAllowed } from '../lib/staff-access.js';

const { t } = i18n;

const TILES: { to: string; titleKey: string; descKey: string; roles?: readonly string[] }[] = [
  {
    to: '/admin/staff-access',
    titleKey: 'staff.title',
    descKey: 'staff.description',
    roles: ['ADMIN'],
  },
  {
    to: '/reports',
    titleKey: 'nav.reports',
    descKey: 'admin.tile.reports.desc',
    roles: ['ADMIN', 'OPERATOR', 'ACCOUNTANT', 'PARTNER_ADMIN', 'ORDER_PLACER'],
  },
  {
    to: '/settings/notifications',
    titleKey: 'nav.notifications',
    descKey: 'admin.tile.notifications.desc',
    roles: ['ADMIN', 'OPERATOR', 'PARTNER_ADMIN', 'ORDER_PLACER'],
  },
  { to: '/settings/appearance', titleKey: 'nav.appearance', descKey: 'admin.tile.appearance.desc' },
  {
    to: '/admin/rbac',
    titleKey: 'admin.tile.rbac.title',
    descKey: 'admin.tile.rbac.desc',
    roles: ['ADMIN'],
  },
  {
    to: '/admin/invitations',
    titleKey: 'admin.tile.invitations.title',
    descKey: 'admin.tile.invitations.desc',
    roles: ['ADMIN'],
  },
  {
    to: '/admin/pricing-tiers',
    titleKey: 'admin.tile.pricing.title',
    descKey: 'admin.tile.pricing.desc',
    roles: ['ADMIN'],
  },
  {
    to: '/admin/holidays',
    titleKey: 'admin.tile.holidays.title',
    descKey: 'admin.tile.holidays.desc',
    roles: ['ADMIN'],
  },
  {
    to: '/admin/email-templates',
    titleKey: 'admin.tile.emails.title',
    descKey: 'admin.tile.emails.desc',
    roles: ['ADMIN'],
  },
  {
    to: '/admin/low-stock-report',
    titleKey: 'admin.tile.low_stock.title',
    descKey: 'admin.tile.low_stock.desc',
    roles: ['ADMIN'],
  },
];

export function AdminHomePage() {
  const { user } = useAuth();
  const roles = user?.roles.map((binding) => binding.role) ?? [];
  const tiles = TILES.filter(
    (tile) =>
      staffRouteAllowed(user, tile.to) &&
      (!tile.roles || tile.roles.some((role) => roles.includes(role))),
  );
  return (
    <section className="space-y-4">
      <header>
        <h2 className="text-xl font-semibold">{t('admin.home.title')}</h2>
        <p className="text-sm text-muted-foreground">{t('admin.home.subtitle')}</p>
      </header>

      <div className="grid gap-3 sm:grid-cols-2">
        {tiles.map((tile) => (
          <Link
            key={tile.to}
            to={tile.to}
            className="block rounded-md border border-border p-4 hover:bg-muted"
          >
            <div className="font-medium">{t(tile.titleKey)}</div>
            <div className="mt-1 text-xs text-muted-foreground">{t(tile.descKey)}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
